import { render } from "./dangjInfo.vue?vue&type=template&id=abe15b50&scoped=true"
import script from "./dangjInfo.vue?vue&type=script&lang=js"
export * from "./dangjInfo.vue?vue&type=script&lang=js"

import "./dangjInfo.vue?vue&type=style&index=0&id=abe15b50&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abe15b50"]])

export default __exports__